import { useEffect, useState } from 'react'
import { Form, message } from 'antd'
import { Input, Drawer } from '@/components/ui'
import { router } from '@inertiajs/react'
import axios from '@/lib/axios'
import '@/styles/compact-form.css'

interface Event {
  id: number
  slug: string
}

interface Venue {
  id: number
  title: string
}

interface VenueDrawerProps {
  event: Event
  venue: Venue | null
  open: boolean
  onClose: () => void
}

export default function VenueDrawer({ event, venue, open, onClose }: VenueDrawerProps) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) {
      if (venue) {
        form.setFieldsValue({
          title: venue.title
        })
      } else {
        form.resetFields()
      }
    }
  }, [open, venue, form])

  const handleSubmit = async (values: any) => {
    setLoading(true)

    try {
      let response
      if (venue) {
        response = await axios.patch(`/events/${event.slug}/agenda/venues/${venue.id}`, {
          venue: values
        })
      } else {
        response = await axios.post(`/events/${event.slug}/agenda/venues`, {
          venue: values
        })
      }

      if (response.data.success) {
        message.success(response.data.message)
        router.reload()
        onClose()
      }
    } catch (error: any) {
      message.error(error.response?.data?.errors?.join(', ') || 'Failed to save venue')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Drawer
      title={venue ? 'Edit Venue' : 'Add Venue'}
      open={open}
      onClose={onClose}
      onSubmit={() => form.submit()}
      submitText={venue ? 'Update' : 'Add'}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="compact-form"
      >
        <Form.Item
          label="Venue Title"
          name="title"
          rules={[{ required: true, message: 'Please enter venue title' }]}
          style={{ marginBottom: 0 }}
        >
          <Input placeholder="Enter venue" size="small" />
        </Form.Item>
      </Form>
    </Drawer>
  )
}
